import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
  useState,
} from 'react';

import { SearchAggregations } from '@/__generated__/graphql';

export type SearchFacetsState = {
  aggregations: Partial<SearchAggregations> | null;
  setAggregations: (aggregations: Partial<SearchAggregations> | null) => void;
};

const SearchFacetsContext = createContext<SearchFacetsState>({
  aggregations: null,
  setAggregations: () => {},
});

export const useSearchFacets = () => {
  return useContext(SearchFacetsContext);
};

export const SearchFacetsProvider: FC<PropsWithChildren<{}>> = ({ children }) => {
  const [aggregations, setAggregations] = useState<Partial<SearchAggregations> | null>(
    null,
  );

  const value = useMemo(
    () => ({
      aggregations,
      setAggregations,
    }),
    [aggregations],
  );

  return (
    <SearchFacetsContext.Provider value={value}>
      {children}
    </SearchFacetsContext.Provider>
  );
};
